import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import NewWebinarForm from "components/Admin/Webinar/NewWebinarForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import shortid from "shortid";
import _ from "lodash";
import { getGallery } from "../../../actions/webinars";

const { CPD_STATUSES, REF_TYPES, CREATE_WEBINAR_SAGA, MODAL_TYPE_WEBINAR } =
  constants;

const {
  setTempWebinar,
  createWebinarSaga,
  cleanErrors,
  loadSponsorsSuggestionsSaga,
  loadPartnersSuggestionsSaga,
  showModal,
  adminPostAssignedUsersSaga,
  loadDisciplinesSaga,
  loadSponsorUsersSuggestionsSaga,
  toggleGallery,
  getZoomAccounts,
} = actions;

class NewWebinar extends Component {
  static propTypes = {
    createWebinar: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    let tempWebinar = {};

    if (
      props.location.state &&
      props.location.state.from === "addUsersWebinar"
    ) {
      tempWebinar = {
        ...props.tempWebinar,
        ...{
          assigned_ids:
            (props.tempWebinar && props.tempWebinar.assigned_ids) || [],
          assigned_users: props.users,
        },
      };
    }

    this.state = {
      webinar: {
        gallery_photo: null,
        assigned_ids: [],
        assigned_users: [],
        user_sponsor_ids: [],
        webinar_type: "online",
        start_date: moment().set("seconds", 0),
        end_date: moment().set("seconds", 0),
        webinar_title: "",
        faculty: false,
        price: 0,
        search_disciplines: [],
        subscription_sponsor: false,
        sponsor_newsleter_title: "",
        landing_show: false,
        for_event: false,
        generate_qrcode: false,
        show_user_questions: true,
        status: "published",
        sponsor_ids: [],
        partnerships_ids: [],
        int_cpd_points: "",
        ext_cpd_points: "",
        cpd_points: "external",
        zoom_uid: "",
        duration: "",
        vimeo_url: "",
        document: null,
        attachmentPreview: "",
        attachmentType: "",
        ppt_document: "",
        ppt_document_url: "",
        pptDocumentType: "",
        evaluation_summary: "",
        evaluation_summary_url: "",
        evaluationSummaryType: "",
        add_custom_text: false,
        custom_text_1: "",
        custom_text_1: "",
        custom_text_2: "",
        gms_study_days: "",
        cpd_status: CPD_STATUSES.granted,
        ref_type: REF_TYPES.ICGP,
        icgp_ref: "",
        ipna_ref: "",
        counties: [],
        disciplines: [],
        user_types: [],
        zoom_account: "",
        spd_quizzes_attributes: [
          { __id: shortid.generate(), question: "", correct: false },
        ],
        sessions_attributes: [
          {
            __id: shortid.generate(),
            title: "",
            start_time: moment().set("seconds", 0),
            end_time: moment().set("seconds", 0),
            rooms_attributes: [
              {
                __id: shortid.generate(),
                title: "",
              },
            ],
          },
        ],
        experts_attributes: [
          {
            __id: shortid.generate(),
            name: "",
            expert_type: "",
            location: "",
            expert_avatar_url: "",
            numeration: "",
            presentation_title: "",
          },
        ],
        ...tempWebinar,
      },
      is_industry: false,
    };

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    if (!this.props.gallery.length) this.props.getGallery();
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.adminPostAssignedUsersSaga(this.state.webinar.assigned_ids);
    this.props.loadAllSponsors();
    this.props.loadAllPartners();
    this.props.loadDisciplines();
    this.props.loadZoomAccounts();
    this.props.loadAllSponsorUsers();
  }

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(
      allCounties,
      this.state.webinar.counties
    );
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {
        ...newWebinar,
        ...{ counties: allCounties.map((county) => county) },
      };
    }

    if (
      this.state.webinar.ext_cpd_points !== 0 &&
      this.state.webinar.int_cpd_points !== 0
    ) {
      newWebinar = {
        ...newWebinar,
        ...{ ext_cpd_points: 0, int_cpd_points: 0 },
      };
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: { ...this.state.webinar, ...newWebinar } });
    }
  };

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const webinarData = {
      ...this.state.webinar,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      console.log({ fieldValue, ipnaMemberIndex });

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 8;
      }

      console.log({ fieldValue });

      this.props.loadDisciplines(fieldValue);
    }

    this.setState({ webinar: webinarData });
  };

  onSponsorChange = (sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "sponsor_ids",
        value: (sponsor_ids || []).map((sponsor) => sponsor.value),
      },
    });
  };

  onPartnerChange = (partnerships_ids) => {
    this.onFieldChange({
      target: {
        name: "partnerships_ids",
        value: (partnerships_ids || []).map((partner) => partner.value),
      },
    });
  };

  onSponsorUsersChange = (user_sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "user_sponsor_ids",
        value: (user_sponsor_ids || []).map((sponsorUser) => sponsorUser.value),
      },
    });
  };

  onCountiesChange = (counties) => {
    this.onFieldChange({
      target: {
        name: "counties",
        value: (counties || []).map((county) => county.value),
      },
    });
  };

  onSelectChangeDisciplineWebinar = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };
  onSelectChangeDisciplineWebinarSearch = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "search_disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };
  onUserTypeChange = (roles) => {
    this.onFieldChange({
      target: {
        name: "user_types",
        value: (roles || []).map((role) => role.value),
      },
    });
  };

  onIsIndustryChange = (e) => {
    const is_industry = e.target.checked;
    this.setState({
      is_industry,
      webinar: {
        ...this.state.webinar,
        user_types: is_industry ? [11] : [],
      },
    });
  };

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onWebinarFacultyTypeChange = (e) => {
    if (!e.target.checked) {
      const webinarData = {
        ...this.state.webinar,
        ...{
          price: 0,
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    } else {
      const webinarData = {
        ...this.state.webinar,
        ...{
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    }
  };

  onNewsletterChange = (e) => {
    const subscription_sponsor = e.target.value;
    this.onFieldChange({
      target: {
        name: "subscription_sponsor",
        value: subscription_sponsor === "true",
      },
    });
  };

  onLandingShowChange = (e) => {
    const landing_show = e.target.value;
    this.onFieldChange({
      target: {
        name: "landing_show",
        value: landing_show === "true",
      },
    });
  };

  onAddCustomTextChange = (e) => {
    const isEnabled = e.target.value === "true";
    this.setState((prevState) => ({
      webinar: {
        ...prevState.webinar,
        add_custom_text: isEnabled,
        ...(!isEnabled && { custom_text_1: "", custom_text_2: "" }),
      },
    }));
  };

  onEventWebinarChange = (e) => {
    const for_event = e.target.value;
    this.onFieldChange({
      target: {
        name: "for_event",
        value: for_event === "true",
      },
    });
  };
  onGenerateQRChange = (e) => {
    const generate_qrcode = e.target.value;
    this.onFieldChange({
      target: {
        name: "generate_qrcode",
        value: generate_qrcode === "true",
      },
    });
  };
  onShowUserQuestions = (e) => {
    const show_user_questions = e.target.value;
    this.onFieldChange({
      target: {
        name: "show_user_questions",
        value: show_user_questions === "true",
      },
    });
  };
  onAssignedUsersChange = (assignedUsers, triggeredAction) => {
    this.onFieldChange({
      target: {
        name: "assigned_ids",
        value: assignedUsers,
      },
    });
  };

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == "internal"
        ? {
            [e.target.name]: input,
            ext_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "external"
        ? {
            [e.target.name]: input,
            int_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "both"
        ? {
            [e.target.name]: input,
          }
        : {}),
    };
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  };

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted
          ? {
              ext_cpd_points: 0,
              int_cpd_points: 0,
              icgp_ref: "",
            }
          : {}),
      },
    });
  };
  onCertificateRefChange = (e) => {
    const value = e.target.value;
    let refType;

    if (value === REF_TYPES.ICGP) {
      refType = {
        icgp_ref: this.state.webinar.icgp_ref || "",
      };
    } else if (value === REF_TYPES.RCPI) {
      refType = {
        rcpi_ref: this.state.webinar.rcpi_ref || "",
      };
    } else {
      refType = {
        ipna_ref: this.state.webinar.ipna_ref || "",
      };
    }

    this.setState({
      webinar: {
        ...this.state.webinar,
        ref_type: e.target.value,
        ...refType,
      },
    });
  };

  onDateChange = (field, value) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        [field]: value,
      },
    };
    this.setState({ webinar: webinarData });
  };

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[{ question: "", correct: false, __id: shortid.generate() }],
          ],
        },
      },
    });
  };

  onQuizRemove = (__id) => {
    const quizzes = this.state.webinar.spd_quizzes_attributes.filter(
      (quiz) => quiz.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: quizzes,
        },
      },
    });
  };

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find((webinar) => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz,
        },
      },
    });
  };

  onSessionAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          sessions_attributes: [
            ...this.state.webinar.sessions_attributes,
            ...[
              {
                __id: shortid.generate(),
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ],
          ],
        },
      },
    });
  };

  onSessionRemove = (__id) => {
    let sessions_attributes = this.state.webinar.sessions_attributes.filter(
      (session) => session.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          sessions_attributes,
        },
      },
    });
  };

  onSessionChange = (__id, field, value) => {
    const sessions_attributes = this.state.webinar.sessions_attributes.slice();
    const session = sessions_attributes.find((session) => session.__id == __id);
    session[field] = value;

    const webinarData = {
      ...this.state.webinar,
      ...{
        sessions_attributes,
      },
    };
    this.setState({ webinar: webinarData });
  };

  // Expert CRUD
  onExpertAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: [
            ...this.state.webinar.experts_attributes,
            ...[
              {
                name: "",
                type: "",
                location: "",
                avatar: "",
                __id: shortid.generate(),
              },
            ],
          ],
        },
      },
    });
  };

  onExpertRemove = (__id) => {
    const experts = this.state.webinar.experts_attributes.filter(
      (expert) => expert.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onExpertChange = (__id, field, value) => {
    let experts = this.state.webinar.experts_attributes.slice();
    let expert = experts.find((webinar) => webinar.__id == __id);
    expert[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onAttachmentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: file,
            attachmentPreview: URL.createObjectURL(file),
            attachmentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: null,
            attachmentPreview: "",
            attachmentType: "",
          },
        },
      });
    }
  };

  onPptDocumentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: file,
            ppt_document_url: URL.createObjectURL(file),
            pptDocumentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: null,
            ppt_document_url: "",
            pptDocumentType: "",
          },
        },
      });
    }
  };

  onEvaluationSummaryChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: file,
            evaluation_summary_url: URL.createObjectURL(file),
            evaluationSummaryType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: null,
            evaluation_summary_url: "",
            evaluationSummaryType: "",
          },
        },
      });
    }
  };

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case "external":
        return ["ext_cpd_points"];
      case "internal":
        return ["int_cpd_points"];
      case "both":
        return ["int_cpd_points", "ext_cpd_points"];
      default:
        return [];
    }
  };

  onSubmit = () => {
    this.state.webinar.log;
    this.props.createWebinar(this.state.webinar);
  };

  goToAddUsersPage = () => {
    this.props.setTempWebinar(this.state.webinar);
    this.props.router.push("/webinars/new/addUsers");
  };

  showUsersModal = (additional = {}) => {
    this.props.showUsersModal(
      {
        users: this.props.users,
      },
      additional
    );
  };

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  handleSelectImage(e) {
    this.setState({
      webinar: {
        ...this.state.webinar,
        gallery_photo: Number(e.target.id),
      },
    });
    this.toggleGallery();
  }
  removeGallery() {
    this.setState({
      webinar: {
        ...this.state.webinar,
        gallery_photo: "",
      },
    });
  }
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    const speakers = reorder(
      this.state.webinar.experts_attributes,
      result.source.index,
      result.destination.index
    ).map((speaker, index) => {
      speaker.numeration = index + 1;
      return speaker;
    });

    this.setState({
      ...this.state,
      webinar: {
        ...this.state.webinar,
        experts_attributes: speakers,
        experts: speakers.filter((speaker) => speaker.expert_type),
      },
    });
  }

  toggleGallery() {
    if (!this.props.gallery.length) this.props.getGallery();
    this.props.toggleGallery();
  }

  render() {
    const { errors, errorsFrontend } = this.props;

    return (
      <main className="site--width clearfix-c">
        <NewWebinarForm
          toggleGallery={this.toggleGallery.bind(this)}
          galleryOpen={this.props.galleryOpen}
          handleSelectImage={this.handleSelectImage.bind(this)}
          removeGallery={this.removeGallery.bind(this)}
          gallery={this.props.gallery}
          role={this.props.role}
          onSessionAdd={this.onSessionAdd}
          onSessionRemove={this.onSessionRemove}
          onSessionChange={this.onSessionChange}
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onDateChange={this.onDateChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCpdTypeChange={this.onCpdTypeChange}
          onCountiesChange={this.onCountiesChange}
          onUserTypeChange={this.onUserTypeChange}
          isIndustry={this.state.is_industry}
          onIsIndustryChange={this.onIsIndustryChange}
          onSponsorChange={this.onSponsorChange}
          onPartnerChange={this.onPartnerChange}
          onSponsorUsersChange={this.onSponsorUsersChange}
          onDisciplinesChange={this.onDisciplinesChange}
          onWiminChange={this.onWiminChange}
          onNewsletterChange={this.onNewsletterChange}
          goToAddUsersPage={this.goToAddUsersPage}
          showUsersModal={this.showUsersModal}
          onAssignedUsersChange={this.onAssignedUsersChange}
          sponsorsOptions={this.props.sponsors}
          partnersOptions={this.props.partners}
          sponsorUsersOptions={this.props.sponsorUsers}
          onConsultantOrHD={this.onConsultantOrHD}
          onCertificateRefChange={this.onCertificateRefChange}
          onWebinarTypeChange={this.onWebinarTypeChange}
          onExpertAdd={this.onExpertAdd}
          onExpertRemove={this.onExpertRemove}
          onExpertChange={this.onExpertChange}
          onWebinarFacultyTypeChange={this.onWebinarFacultyTypeChange}
          onAttachmentChange={this.onAttachmentChange}
          attachmentPreview={this.state.webinar.attachmentPreview}
          attachmentType={this.state.webinar.attachmentType}
          onPptDocumentChange={this.onPptDocumentChange}
          ppt_document={this.state.webinar.ppt_document}
          ppt_document_url={this.state.webinar.ppt_document_url}
          pptDocumentType={this.state.webinar.pptDocumentType}
          evaluation_summary={this.state.webinar.evaluation_summary}
          evaluation_summary_url={this.state.webinar.evaluation_summary_url}
          evaluationSummaryType={this.state.webinar.evaluationSummaryType}
          onEvaluationSummaryChange={this.onEvaluationSummaryChange}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDisciplineWebinar}
          onSelectChangeDisciplineSearch={
            this.onSelectChangeDisciplineWebinarSearch
          }
          onLandingShowChange={this.onLandingShowChange}
          onEventWebinarChange={this.onEventWebinarChange}
          search_disciplines={this.props.search_disciplines}
          onDragEnd={this.onDragEnd}
          onGenerateQRChange={this.onGenerateQRChange}
          onShowUserQuestions={this.onShowUserQuestions}
          zoomAccounts={this.props.zoomAccounts}
          onAddCustomTextChange={this.onAddCustomTextChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    tempWebinar: state.webinars.tmp,
    users: state.users.assignedUsers.values,
    errors: state.errors[CREATE_WEBINAR_SAGA],
    errorsFrontend: state.errors[`${CREATE_WEBINAR_SAGA}_FRONTEND`],
    sponsors: state.suggestions.sponsor.values,
    partners: state.suggestions.partner.values,
    disciplines: state.disciplines.list.values,
    search_disciplines: state.disciplines.search.values,
    count: state.disciplines.list.count,
    total_pages: state.disciplines.list.total_pages,
    page: state.disciplines.list.page,
    query: state.disciplines.list.query,
    sponsorUsers: state.suggestions.sponsorUsers.values,
    role: state.users.user.role,
    gallery: state.webinars.gallery,
    galleryOpen: state.webinars.galleryOpen,
    zoomAccounts: state.zoom.zoomAccounts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    createWebinar: (webinar) => dispatch(createWebinarSaga(webinar)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_WEBINAR_SAGA)),
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
    loadAllPartners: () => dispatch(loadPartnersSuggestionsSaga()),
    showUsersModal: (contentProps) =>
      dispatch(showModal(MODAL_TYPE_WEBINAR, contentProps)),
    adminPostAssignedUsersSaga: (assigned_ids, onlyAssigned = true) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_ids, onlyAssigned, 0, {}, 0)
      ),
    dispatch: dispatch,
    loadDisciplines: (userType) =>
      dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
    loadAllSponsorUsers: () => dispatch(loadSponsorUsersSuggestionsSaga()),
    toggleGallery: () => dispatch(toggleGallery()),
    getGallery: (meta) => dispatch(getGallery(meta)),
    loadZoomAccounts: () => dispatch(getZoomAccounts()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewWebinar);



// WEBPACK FOOTER //
// ./src/containers/Admin/Webinar/NewWebinar.jsx